module.exports = __webpack_public_path__ + "img/verrues.8857c44c.jpg";